import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

import { Columns3 } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import type { ColumnToggleOption } from '@/composables/useColumnVisibilityOverrides';

/*
 * A records page's column-visibility control: a small dropdown of checkboxes, one per toggleable
 * column that is currently on offer (already presence-gated by the caller), plus Select all/Deselect
 * all. Shared by every page that offers this control - see `useColumnVisibilityOverrides` for why the
 * underlying show/hide logic is generic while each page still owns its own column list and defaults.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnVisibilityMenu',
  props: {
    options: {},
    label: {},
    iconOnly: { type: Boolean }
  },
  emits: ["toggle", "select-all", "deselect-all"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenu), { modal: false }, {
    default: _withCtx(() => [
      _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "outline",
            size: _ctx.iconOnly ? 'icon' : 'sm',
            class: "gap-x-2",
            "aria-label": _ctx.iconOnly ? _ctx.label : undefined,
            title: _ctx.iconOnly ? _ctx.label : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Columns3), {
                class: "size-4",
                "aria-hidden": "true"
              }),
              (!_ctx.iconOnly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["size", "aria-label", "title"])
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenuContent), {
        class: "min-w-56",
        align: "end"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createBlock(_unref(DropdownMenuCheckboxItem), {
              key: option.id,
              checked: option.checked,
              "indicator-right": "",
              onSelect: _withModifiers(($event: any) => (emit('toggle', option.id)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.label), 1)
              ]),
              _: 2
            }, 1032, ["checked", "onSelect"]))
          }), 128)),
          _createVNode(_unref(DropdownMenuSeparator)),
          _createVNode(_unref(DropdownMenuItem), {
            disabled: _ctx.options.every((option) => option.checked),
            class: "justify-center text-center",
            onSelect: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('select-all')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.uiElements.multiSelect.selectAllButtonLabel')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(DropdownMenuItem), {
            disabled: _ctx.options.every((option) => !option.checked),
            class: "justify-center text-center",
            onSelect: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('deselect-all')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.uiElements.multiSelect.deselectAllButtonLabel')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})